export interface CuratedIndianLocation {
  google_place_id: string;
  formatted_address: string;
  main_text: string;
  secondary_text: string;
  country: string;
  state: string;
  district: string;
  city: string;
  postal_code: string;
  latitude: number;
  longitude: number;
  keywords?: string[];
}

export const INDIAN_LOCATIONS_DATA: CuratedIndianLocation[] = [
  // ================= WEST BENGAL — KOLKATA & GREATER KOLKATA =================
  {
    google_place_id: 'ChIJ_newtown_kol',
    formatted_address: 'New Town, Action Area I, Kolkata, North 24 Parganas, West Bengal 700156, India',
    main_text: 'New Town, Action Area I',
    secondary_text: 'Kolkata, West Bengal 700156, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'New Town',
    postal_code: '700156',
    latitude: 22.5867,
    longitude: 88.475,
    keywords: ['newtown', 'rajarhat', 'action area 1', 'action area ii', 'action area iii', 'axis mall', 'biswa bangla gate'],
  },
  {
    google_place_id: 'ChIJ_ecopark_kol',
    formatted_address: 'Eco Park, New Town, Action Area II, Kolkata, West Bengal 700156, India',
    main_text: 'Eco Park, New Town',
    secondary_text: 'Action Area II, Kolkata, West Bengal 700156, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'Kolkata',
    postal_code: '700156',
    latitude: 22.6196,
    longitude: 88.4666,
    keywords: ['prakriti tirtha', 'new town', 'rajarhat', 'eco park gate'],
  },
  {
    google_place_id: 'ChIJ_saltlake_kol',
    formatted_address: 'Salt Lake Sector V, Bidhannagar, Kolkata, North 24 Parganas, West Bengal 700091, India',
    main_text: 'Salt Lake Sector V, Bidhannagar',
    secondary_text: 'Kolkata, West Bengal 700091, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'Bidhannagar',
    postal_code: '700091',
    latitude: 22.5726,
    longitude: 88.4339,
    keywords: ['salt lake', 'sector 5', 'sector v', 'bidhannagar', 'rdb boulevard', 'college more', 'technopolis'],
  },
  {
    google_place_id: 'ChIJ_citycentre1_kol',
    formatted_address: 'City Centre 1, Salt Lake Sector I, Bidhannagar, Kolkata, West Bengal 700064, India',
    main_text: 'City Centre 1, Salt Lake Sector I',
    secondary_text: 'Bidhannagar, Kolkata, West Bengal 700064, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'Kolkata',
    postal_code: '700064',
    latitude: 22.5892,
    longitude: 88.4084,
    keywords: ['salt lake sector 1', 'sector 2', 'sector 3', 'city center salt lake'],
  },
  {
    google_place_id: 'ChIJ_kolkata_wb',
    formatted_address: 'Park Street, Kolkata, West Bengal 700016, India',
    main_text: 'Park Street',
    secondary_text: 'Kolkata, West Bengal 700016, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700016',
    latitude: 22.5535,
    longitude: 88.3525,
    keywords: ['mother teresa sarani', 'flury', 'peter cat', 'mocambo', 'park street metro', 'camac street'],
  },
  {
    google_place_id: 'ChIJ_questmall_kol',
    formatted_address: 'Quest Mall, Syed Amir Ali Ave, Park Circus, Ballygunge, Kolkata, West Bengal 700017, India',
    main_text: 'Quest Mall, Park Circus',
    secondary_text: 'Ballygunge, Kolkata, West Bengal 700017, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700017',
    latitude: 22.539,
    longitude: 88.3657,
    keywords: ['quest mall', 'park circus', 'beckbagan'],
  },
  {
    google_place_id: 'ChIJ_ballygunge_kol',
    formatted_address: 'Ballygunge, Gariahat, Kolkata, West Bengal 700019, India',
    main_text: 'Ballygunge & Gariahat',
    secondary_text: 'Kolkata, West Bengal 700019, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700019',
    latitude: 22.528,
    longitude: 88.3655,
    keywords: ['gariahat', 'golpark', 'hindustan park', 'southern avenue', 'rabindra sarobar', 'triangular park'],
  },
  {
    google_place_id: 'ChIJ_southcity_kol',
    formatted_address: 'South City Mall, Prince Anwar Shah Road, Jadavpur, Kolkata, West Bengal 700068, India',
    main_text: 'South City Mall, Jadavpur',
    secondary_text: 'Prince Anwar Shah Road, Kolkata, West Bengal 700068, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700068',
    latitude: 22.5015,
    longitude: 88.3617,
    keywords: ['south city', 'jadavpur', 'tollygunge', 'lake gardens', 'dhakuria', 'anwar shah'],
  },
  {
    google_place_id: 'ChIJ_alipore_kol',
    formatted_address: 'Alipore & New Alipore, Kolkata, West Bengal 700027, India',
    main_text: 'Alipore',
    secondary_text: 'Kolkata, West Bengal 700027, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700027',
    latitude: 22.5322,
    longitude: 88.3324,
    keywords: ['new alipore', 'behala', 'bhawanipore', 'kalighat', 'national library'],
  },
  {
    google_place_id: 'ChIJ_esplanade_kol',
    formatted_address: 'Esplanade & Victoria Memorial, Central Kolkata, West Bengal 700069, India',
    main_text: 'Esplanade & Victoria Memorial',
    secondary_text: 'Central Kolkata, West Bengal 700069, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700069',
    latitude: 22.5448,
    longitude: 88.3426,
    keywords: ['new market', 'maidan', 'princep ghat', 'dharmatala', 'bbdbagh', 'dalhousie', 'sealdah'],
  },
  {
    google_place_id: 'ChIJ_acropolis_kol',
    formatted_address: 'Acropolis Mall, Rajdanga Main Road, Kasba, Kolkata, West Bengal 700107, India',
    main_text: 'Acropolis Mall, Kasba',
    secondary_text: 'EM Bypass / Ruby, Kolkata, West Bengal 700107, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Kolkata',
    city: 'Kolkata',
    postal_code: '700107',
    latitude: 22.5145,
    longitude: 88.3932,
    keywords: ['kasba', 'ruby', 'em bypass', 'science city', 'garia', 'patuli'],
  },
  {
    google_place_id: 'ChIJ_dumdum_kol',
    formatted_address: 'Chinar Park & Dum Dum Airport Area, Rajarhat, Kolkata, West Bengal 700157, India',
    main_text: 'Chinar Park & Dum Dum Airport',
    secondary_text: 'VIP Road / Rajarhat, Kolkata, West Bengal 700157, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'Kolkata',
    postal_code: '700157',
    latitude: 22.6263,
    longitude: 88.4342,
    keywords: ['city centre 2', 'cc2', 'vip road', 'lake town', 'baguiati', 'nagerbazar', 'ultadanga', 'shyambazar', 'kankurgachi'],
  },
  {
    google_place_id: 'ChIJ_howrah_wb',
    formatted_address: 'Howrah, Howrah District, West Bengal 711101, India',
    main_text: 'Howrah',
    secondary_text: 'Howrah District, West Bengal 711101, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Howrah',
    city: 'Howrah',
    postal_code: '711101',
    latitude: 22.5958,
    longitude: 88.2636,
    keywords: ['howrah station', 'shibpur', 'avani riverside mall', 'santragachi', 'liluah', 'bally', 'belur'],
  },
  {
    google_place_id: 'ChIJ_barasat_wb',
    formatted_address: 'Barasat & Madhyamgram, North 24 Parganas, West Bengal 700124, India',
    main_text: 'Barasat & Madhyamgram',
    secondary_text: 'North 24 Parganas, West Bengal 700124, India',
    country: 'India',
    state: 'West Bengal',
    district: 'North 24 Parganas',
    city: 'Barasat',
    postal_code: '700124',
    latitude: 22.7225,
    longitude: 88.4806,
    keywords: ['barrackpore', 'sodepur', 'belgharia', 'khardah', 'naihati', 'kalyani'],
  },
  {
    google_place_id: 'ChIJ_serampore_wb',
    formatted_address: 'Serampore & Chandannagar, Hooghly, West Bengal 712201, India',
    main_text: 'Serampore & Chandannagar',
    secondary_text: 'Hooghly District, West Bengal 712201, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Hooghly',
    city: 'Serampore',
    postal_code: '712201',
    latitude: 22.752,
    longitude: 88.342,
    keywords: ['uttarpara', 'rishra', 'chinsurah', 'bandel', 'hooghly', 'dankuni'],
  },
  {
    google_place_id: 'ChIJ_siliguri_wb',
    formatted_address: 'Sevoke Road, Siliguri, Darjeeling, West Bengal 734001, India',
    main_text: 'Sevoke Road, Siliguri',
    secondary_text: 'Darjeeling District, West Bengal 734001, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Darjeeling',
    city: 'Siliguri',
    postal_code: '734001',
    latitude: 26.7271,
    longitude: 88.3953,
    keywords: ['city centre siliguri', 'vega circle', 'matigara', 'bagdogra', 'hill cart road', 'pradhan nagar'],
  },
  {
    google_place_id: 'ChIJ_darjeeling_wb',
    formatted_address: 'Chowrasta Mall Road, Darjeeling, West Bengal 734101, India',
    main_text: 'Mall Road, Darjeeling',
    secondary_text: 'Darjeeling District, West Bengal 734101, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Darjeeling',
    city: 'Darjeeling',
    postal_code: '734101',
    latitude: 27.041,
    longitude: 88.2663,
    keywords: ['chowrasta', 'kalimpong', 'kurseong', 'glenburn'],
  },
  {
    google_place_id: 'ChIJ_bardhaman_wb',
    formatted_address: 'Bardhaman, Purba Bardhaman, West Bengal 713101, India',
    main_text: 'Bardhaman (Burdwan)',
    secondary_text: 'Purba Bardhaman, West Bengal 713101, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Purba Bardhaman',
    city: 'Bardhaman',
    postal_code: '713101',
    latitude: 23.2324,
    longitude: 87.8615,
    keywords: ['burdwan', 'curzon gate', 'gt road bardhaman'],
  },
  {
    google_place_id: 'ChIJ_durgapur_wb',
    formatted_address: 'City Centre, Durgapur, Paschim Bardhaman, West Bengal 713216, India',
    main_text: 'City Centre, Durgapur',
    secondary_text: 'Paschim Bardhaman, West Bengal 713216, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Paschim Bardhaman',
    city: 'Durgapur',
    postal_code: '713216',
    latitude: 23.5204,
    longitude: 87.3119,
    keywords: ['junction mall durgapur', 'benachity', 'bidhannagar durgapur', 'asansol'],
  },
  {
    google_place_id: 'ChIJ_asansol_wb',
    formatted_address: 'Sentrum Mall, Asansol, Paschim Bardhaman, West Bengal 713304, India',
    main_text: 'Asansol',
    secondary_text: 'Paschim Bardhaman, West Bengal 713304, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Paschim Bardhaman',
    city: 'Asansol',
    postal_code: '713304',
    latitude: 23.6889,
    longitude: 86.9661,
    keywords: ['burnpur', 'raniganj', 'gt road asansol'],
  },
  {
    google_place_id: 'ChIJ_digha_wb',
    formatted_address: 'New Digha Sea Beach, Purba Medinipur, West Bengal 721428, India',
    main_text: 'New Digha Sea Beach',
    secondary_text: 'Purba Medinipur, West Bengal 721428, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Purba Medinipur',
    city: 'Digha',
    postal_code: '721428',
    latitude: 21.6266,
    longitude: 87.5074,
    keywords: ['old digha', 'mandarmani', 'tajpur', 'shankarpur', 'contai', 'haldia'],
  },
  {
    google_place_id: 'ChIJ_shantiniketan_wb',
    formatted_address: 'Shantiniketan, Bolpur, Birbhum, West Bengal 731204, India',
    main_text: 'Shantiniketan, Bolpur',
    secondary_text: 'Birbhum, West Bengal 731204, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Birbhum',
    city: 'Bolpur',
    postal_code: '731204',
    latitude: 23.6776,
    longitude: 87.6852,
    keywords: ['visva bharati', 'sonajhuri', 'bolpur', 'tarapith', 'suri'],
  },
  {
    google_place_id: 'ChIJ_kharagpur_wb',
    formatted_address: 'Kharagpur & Midnapore, Paschim Medinipur, West Bengal 721301, India',
    main_text: 'Kharagpur',
    secondary_text: 'Paschim Medinipur, West Bengal 721301, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Paschim Medinipur',
    city: 'Kharagpur',
    postal_code: '721301',
    latitude: 22.346,
    longitude: 87.232,
    keywords: ['iit kharagpur', 'medinipur', 'midnapore', 'jhargram', 'bankura', 'purulia', 'bishnupur'],
  },
  {
    google_place_id: 'ChIJ_malda_wb',
    formatted_address: 'English Bazar, Malda, West Bengal 732101, India',
    main_text: 'Malda (English Bazar)',
    secondary_text: 'Malda District, West Bengal 732101, India',
    country: 'India',
    state: 'West Bengal',
    district: 'Malda',
    city: 'Malda',
    postal_code: '732101',
    latitude: 25.0108,
    longitude: 88.1411,
    keywords: ['berhampore', 'murshidabad', 'krishnanagar', 'nadia', 'raiganj', 'balurghat', 'cooch behar', 'jalpaiguri', 'alipurduar'],
  },

  // ================= MAHARASHTRA — MUMBAI, PUNE & MORE =================
  {
    google_place_id: 'ChIJ_mumbai_mh',
    formatted_address: 'Bandra West, Mumbai, Mumbai Suburban, Maharashtra 400050, India',
    main_text: 'Bandra West',
    secondary_text: 'Mumbai, Maharashtra 400050, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Mumbai Suburban',
    city: 'Mumbai',
    postal_code: '400050',
    latitude: 19.0596,
    longitude: 72.8295,
    keywords: ['linking road', 'carter road', 'bandstand', 'bkc', 'bandra kurla complex', 'khar', 'santacruz'],
  },
  {
    google_place_id: 'ChIJ_colaba_mumbai',
    formatted_address: 'Colaba & Marine Drive, South Mumbai, Maharashtra 400001, India',
    main_text: 'Colaba & Marine Drive',
    secondary_text: 'South Mumbai, Maharashtra 400001, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Mumbai City',
    city: 'Mumbai',
    postal_code: '400001',
    latitude: 18.922,
    longitude: 72.8347,
    keywords: ['gateway of india', 'nariman point', 'fort', 'churchgate', 'kala ghoda', 'cuffe parade', 'worli', 'lower parel', 'palladium'],
  },
  {
    google_place_id: 'ChIJ_andheri_mumbai',
    formatted_address: 'Juhu & Andheri West, Mumbai, Maharashtra 400053, India',
    main_text: 'Juhu & Andheri West',
    secondary_text: 'Mumbai, Maharashtra 400053, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Mumbai Suburban',
    city: 'Mumbai',
    postal_code: '400053',
    latitude: 19.1136,
    longitude: 72.8697,
    keywords: ['juhu beach', 'versova', 'lokhandwala', 'oshivara', 'andheri east', 'goregaon', 'malad', 'borivali'],
  },
  {
    google_place_id: 'ChIJ_powai_mumbai',
    formatted_address: 'Hiranandani Gardens, Powai, Mumbai, Maharashtra 400076, India',
    main_text: 'Hiranandani Gardens, Powai',
    secondary_text: 'Mumbai, Maharashtra 400076, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Mumbai Suburban',
    city: 'Mumbai',
    postal_code: '400076',
    latitude: 19.1197,
    longitude: 72.9051,
    keywords: ['powai lake', 'ghatkopar', 'kurla', 'phoenix marketcity mumbai', 'chembur', 'dadar'],
  },
  {
    google_place_id: 'ChIJ_navimumbai_mh',
    formatted_address: 'Vashi & Seawoods, Navi Mumbai, Thane, Maharashtra 400703, India',
    main_text: 'Vashi & Seawoods, Navi Mumbai',
    secondary_text: 'Navi Mumbai, Maharashtra 400703, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Thane',
    city: 'Navi Mumbai',
    postal_code: '400703',
    latitude: 19.0771,
    longitude: 72.9986,
    keywords: ['inorbit vashi', 'seawoods grand central', 'belapur', 'nerul', 'kharghar', 'panvel', 'thane', 'viviana mall'],
  },
  {
    google_place_id: 'ChIJ_pune_kp',
    formatted_address: 'Koregaon Park & Kalyani Nagar, Pune, Maharashtra 411001, India',
    main_text: 'Koregaon Park & Kalyani Nagar',
    secondary_text: 'Pune, Maharashtra 411001, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Pune',
    city: 'Pune',
    postal_code: '411001',
    latitude: 18.5362,
    longitude: 73.894,
    keywords: ['viman nagar', 'phoenix marketcity pune', 'mg road pune', 'camp', 'fc road', 'shivajinagar', 'deccan'],
  },
  {
    google_place_id: 'ChIJ_pune_baner',
    formatted_address: 'Baner & Balewadi High Street, Pune, Maharashtra 411045, India',
    main_text: 'Baner & Balewadi High Street',
    secondary_text: 'Pune, Maharashtra 411045, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Pune',
    city: 'Pune',
    postal_code: '411045',
    latitude: 18.559,
    longitude: 73.7868,
    keywords: ['hinjewadi', 'aundh', 'wakad', 'kothrud', 'hadapsar', 'magarpatta', 'pimpri', 'chinchwad', 'lonavala'],
  },
  {
    google_place_id: 'ChIJ_nagpur_mh',
    formatted_address: 'Dharampeth & Sitabuldi, Nagpur, Maharashtra 440010, India',
    main_text: 'Dharampeth & Sitabuldi, Nagpur',
    secondary_text: 'Nagpur, Maharashtra 440010, India',
    country: 'India',
    state: 'Maharashtra',
    district: 'Nagpur',
    city: 'Nagpur',
    postal_code: '440010',
    latitude: 21.1458,
    longitude: 79.0882,
    keywords: ['nashik', 'aurangabad', 'sambhajinagar', 'kolhapur', 'mahabaleshwar', 'shirdi'],
  },

  // ================= DELHI NCR (NEW DELHI, GURUGRAM, NOIDA) =================
  {
    google_place_id: 'ChIJ_delhi_dl',
    formatted_address: 'Connaught Place, New Delhi, Delhi 110001, India',
    main_text: 'Connaught Place (CP)',
    secondary_text: 'New Delhi, Delhi 110001, India',
    country: 'India',
    state: 'Delhi',
    district: 'New Delhi',
    city: 'New Delhi',
    postal_code: '110001',
    latitude: 28.6315,
    longitude: 77.2167,
    keywords: ['cp', 'rajiv chowk', 'janpath', 'khan market', 'india gate', 'chanakyapuri', 'mandi house', 'karol bagh'],
  },
  {
    google_place_id: 'ChIJ_southdelhi_dl',
    formatted_address: 'Select Citywalk, Saket & Hauz Khas, South Delhi, New Delhi 110017, India',
    main_text: 'Saket & Hauz Khas, South Delhi',
    secondary_text: 'New Delhi, Delhi 110017, India',
    country: 'India',
    state: 'Delhi',
    district: 'South Delhi',
    city: 'New Delhi',
    postal_code: '110017',
    latitude: 28.5286,
    longitude: 77.2193,
    keywords: ['select citywalk', 'greater kailash', 'gk1', 'gk2', 'vasant kunj', 'dlf promenade', 'defence colony', 'lajpat nagar', 'nehru place', 'aerocity', 'dwarka', 'rajouri garden', 'rohini'],
  },
  {
    google_place_id: 'ChIJ_gurugram_hr',
    formatted_address: 'DLF CyberHub, Cyber City, Gurugram, Haryana 122002, India',
    main_text: 'DLF CyberHub, Gurugram',
    secondary_text: 'Cyber City, Gurugram, Haryana 122002, India',
    country: 'India',
    state: 'Haryana',
    district: 'Gurugram',
    city: 'Gurugram',
    postal_code: '122002',
    latitude: 28.495,
    longitude: 77.0895,
    keywords: ['gurgaon', 'cyber hub', 'golf course road', 'mg road gurgaon', 'galleria market', 'sector 29', 'ambience mall gurgaon', 'sohna road', 'faridabad'],
  },
  {
    google_place_id: 'ChIJ_noida_up',
    formatted_address: 'DLF Mall of India, Sector 18, Noida, Gautam Buddha Nagar, Uttar Pradesh 201301, India',
    main_text: 'Sector 18 & DLF Mall of India, Noida',
    secondary_text: 'Noida, Uttar Pradesh 201301, India',
    country: 'India',
    state: 'Uttar Pradesh',
    district: 'Gautam Buddha Nagar',
    city: 'Noida',
    postal_code: '201301',
    latitude: 28.5672,
    longitude: 77.3211,
    keywords: ['sector 62 noida', 'greater noida', 'gardens galleria', 'indirapuram', 'ghaziabad'],
  },

  // ================= KARNATAKA — BENGALURU & MORE =================
  {
    google_place_id: 'ChIJ_bangalore_ka',
    formatted_address: 'MG Road, Bengaluru, Bangalore Urban, Karnataka 560001, India',
    main_text: 'MG Road & UB City, Bengaluru',
    secondary_text: 'Bengaluru, Karnataka 560001, India',
    country: 'India',
    state: 'Karnataka',
    district: 'Bangalore Urban',
    city: 'Bengaluru',
    postal_code: '560001',
    latitude: 12.9716,
    longitude: 77.5946,
    keywords: ['bangalore', 'brigade road', 'church street', 'ub city', 'lavelle road', 'residency road', 'cubbon park'],
  },
  {
    google_place_id: 'ChIJ_indiranagar_blr',
    formatted_address: 'Indiranagar & Koramangala, Bengaluru, Karnataka 560038, India',
    main_text: 'Indiranagar & Koramangala',
    secondary_text: 'Bengaluru, Karnataka 560038, India',
    country: 'India',
    state: 'Karnataka',
    district: 'Bangalore Urban',
    city: 'Bengaluru',
    postal_code: '560038',
    latitude: 12.9784,
    longitude: 77.6408,
    keywords: ['100 feet road', 'koramangala 5th block', 'hsr layout', 'jayanagar', 'jp nagar', 'malleshwaram', 'bangalore'],
  },
  {
    google_place_id: 'ChIJ_whitefield_blr',
    formatted_address: 'Phoenix Marketcity, Whitefield, Bengaluru, Karnataka 560048, India',
    main_text: 'Whitefield & Phoenix Marketcity',
    secondary_text: 'Bengaluru, Karnataka 560048, India',
    country: 'India',
    state: 'Karnataka',
    district: 'Bangalore Urban',
    city: 'Bengaluru',
    postal_code: '560048',
    latitude: 12.9958,
    longitude: 77.6964,
    keywords: ['itpl', 'marathahalli', 'bellandur', 'sarjapur road', 'electronic city', 'hebbal', 'manyata tech park', 'yelahanka'],
  },
  {
    google_place_id: 'ChIJ_mysuru_ka',
    formatted_address: 'Mysuru (Mysore), Karnataka 570001, India',
    main_text: 'Mysuru (Mysore)',
    secondary_text: 'Karnataka 570001, India',
    country: 'India',
    state: 'Karnataka',
    district: 'Mysuru',
    city: 'Mysuru',
    postal_code: '570001',
    latitude: 12.2958,
    longitude: 76.6394,
    keywords: ['mysore', 'mangaluru', 'mangalore', 'manipal', 'udupi', 'hubli', 'coorg', 'madikeri'],
  },

  // ================= TELANGANA & ANDHRA PRADESH =================
  {
    google_place_id: 'ChIJ_hyderabad_ts',
    formatted_address: 'Banjara Hills & Jubilee Hills, Hyderabad, Telangana 500034, India',
    main_text: 'Banjara Hills & Jubilee Hills',
    secondary_text: 'Hyderabad, Telangana 500034, India',
    country: 'India',
    state: 'Telangana',
    district: 'Hyderabad',
    city: 'Hyderabad',
    postal_code: '500034',
    latitude: 17.4156,
    longitude: 78.4347,
    keywords: ['gvk one', 'somajiguda', 'begumpet', 'necklace road', 'hussain sagar', 'secunderabad'],
  },
  {
    google_place_id: 'ChIJ_hiteccity_hyd',
    formatted_address: 'HITEC City & Gachibowli, Madhapur, Hyderabad, Telangana 500081, India',
    main_text: 'HITEC City & Gachibowli',
    secondary_text: 'Madhapur, Hyderabad, Telangana 500081, India',
    country: 'India',
    state: 'Telangana',
    district: 'Ranga Reddy',
    city: 'Hyderabad',
    postal_code: '500081',
    latitude: 17.4435,
    longitude: 78.3772,
    keywords: ['inorbit cyberabad', 'mindspace', 'kondapur', 'kukatpally', 'financial district'],
  },
  {
    google_place_id: 'ChIJ_vizag_ap',
    formatted_address: 'RK Beach & Siripuram, Visakhapatnam, Andhra Pradesh 530003, India',
    main_text: 'RK Beach & Siripuram, Visakhapatnam',
    secondary_text: 'Visakhapatnam, Andhra Pradesh 530003, India',
    country: 'India',
    state: 'Andhra Pradesh',
    district: 'Visakhapatnam',
    city: 'Visakhapatnam',
    postal_code: '530003',
    latitude: 17.7143,
    longitude: 83.3236,
    keywords: ['vizag', 'mvp colony', 'vijayawada', 'tirupati', 'guntur'],
  },

  // ================= TAMIL NADU & PUDUCHERRY =================
  {
    google_place_id: 'ChIJ_chennai_tn',
    formatted_address: 'T. Nagar & Nungambakkam, Chennai, Tamil Nadu 600017, India',
    main_text: 'T. Nagar & Nungambakkam, Chennai',
    secondary_text: 'Chennai, Tamil Nadu 600017, India',
    country: 'India',
    state: 'Tamil Nadu',
    district: 'Chennai',
    city: 'Chennai',
    postal_code: '600017',
    latitude: 13.0418,
    longitude: 80.2341,
    keywords: ['anna nagar', 'adyar', 'besant nagar', 'velachery', 'phoenix marketcity chennai', 'marina beach', 'omr', 'ecr', 'guindy', 'mylapore'],
  },
  {
    google_place_id: 'ChIJ_coimbatore_tn',
    formatted_address: 'RS Puram & Race Course, Coimbatore, Tamil Nadu 641002, India',
    main_text: 'RS Puram, Coimbatore',
    secondary_text: 'Coimbatore, Tamil Nadu 641002, India',
    country: 'India',
    state: 'Tamil Nadu',
    district: 'Coimbatore',
    city: 'Coimbatore',
    postal_code: '641002',
    latitude: 11.0081,
    longitude: 76.9516,
    keywords: ['brookefields mall', 'madurai', 'trichy', 'tiruchirappalli', 'ooty', 'kodaikanal', 'puducherry', 'pondicherry', 'white town'],
  },

  // ================= GUJARAT, RAJASTHAN, GOA & KERALA =================
  {
    google_place_id: 'ChIJ_ahmedabad_gj',
    formatted_address: 'SG Highway & Navrangpura, Ahmedabad, Gujarat 380009, India',
    main_text: 'SG Highway & Navrangpura, Ahmedabad',
    secondary_text: 'Ahmedabad, Gujarat 380009, India',
    country: 'India',
    state: 'Gujarat',
    district: 'Ahmedabad',
    city: 'Ahmedabad',
    postal_code: '380009',
    latitude: 23.0225,
    longitude: 72.5714,
    keywords: ['cg road', 'prahlad nagar', 'sabarmati riverfront', 'palladium ahmedabad', 'gandhinagar', 'surat', 'vadodara', 'rajkot'],
  },
  {
    google_place_id: 'ChIJ_jaipur_rj',
    formatted_address: 'C-Scheme & Malviya Nagar (World Trade Park), Jaipur, Rajasthan 302017, India',
    main_text: 'C-Scheme & World Trade Park, Jaipur',
    secondary_text: 'Jaipur, Rajasthan 302017, India',
    country: 'India',
    state: 'Rajasthan',
    district: 'Jaipur',
    city: 'Jaipur',
    postal_code: '302017',
    latitude: 26.853,
    longitude: 75.8047,
    keywords: ['mi road', 'vaishali nagar', 'udaipur', 'jodhpur', 'jaisalmer', 'ajmer', 'pushkar', 'kota'],
  },
  {
    google_place_id: 'ChIJ_goa_ga',
    formatted_address: 'Panaji, Candolim & Calangute, North Goa, Goa 403001, India',
    main_text: 'Panaji & Candolim, North Goa',
    secondary_text: 'Goa 403001, India',
    country: 'India',
    state: 'Goa',
    district: 'North Goa',
    city: 'Panaji',
    postal_code: '403001',
    latitude: 15.4909,
    longitude: 73.8278,
    keywords: ['panjim', 'baga', 'anjuna', 'vagator', 'morjim', 'assagao', 'margao', 'south goa', 'vasco'],
  },
  {
    google_place_id: 'ChIJ_kochi_kl',
    formatted_address: 'Marine Drive & Lulu Mall Edappally, Kochi, Ernakulam, Kerala 682024, India',
    main_text: 'Marine Drive & Lulu Mall, Kochi',
    secondary_text: 'Ernakulam, Kerala 682024, India',
    country: 'India',
    state: 'Kerala',
    district: 'Ernakulam',
    city: 'Kochi',
    postal_code: '682024',
    latitude: 10.0261,
    longitude: 76.3125,
    keywords: ['cochin', 'fort kochi', 'kakkanad', 'thiruvananthapuram', 'trivandrum', 'kozhikode', 'calicut', 'munnar'],
  },

  // ================= EAST, NORTH & CENTRAL INDIA =================
  {
    google_place_id: 'ChIJ_bhubaneswar_od',
    formatted_address: 'Esplanade One & Patia, Bhubaneswar, Khordha, Odisha 751010, India',
    main_text: 'Esplanade One & Patia, Bhubaneswar',
    secondary_text: 'Bhubaneswar, Odisha 751010, India',
    country: 'India',
    state: 'Odisha',
    district: 'Khordha',
    city: 'Bhubaneswar',
    postal_code: '751010',
    latitude: 20.2961,
    longitude: 85.8245,
    keywords: ['saheed nagar', 'cuttack', 'puri', 'rourkela', 'odisha'],
  },
  {
    google_place_id: 'ChIJ_guwahati_as',
    formatted_address: 'GS Road & City Center Mall, Guwahati, Kamrup Metropolitan, Assam 781005, India',
    main_text: 'GS Road & City Center, Guwahati',
    secondary_text: 'Guwahati, Assam 781005, India',
    country: 'India',
    state: 'Assam',
    district: 'Kamrup Metropolitan',
    city: 'Guwahati',
    postal_code: '781005',
    latitude: 26.1445,
    longitude: 91.7362,
    keywords: ['paltan bazar', 'fancy bazar', 'dispur', 'shillong', 'gangtok', 'agartala', 'dibrugarh', 'silchar'],
  },
  {
    google_place_id: 'ChIJ_patna_br',
    formatted_address: 'Boring Road & Fraser Road (City Centre), Patna, Bihar 800001, India',
    main_text: 'Boring Road & City Centre, Patna',
    secondary_text: 'Patna, Bihar 800001, India',
    country: 'India',
    state: 'Bihar',
    district: 'Patna',
    city: 'Patna',
    postal_code: '800001',
    latitude: 25.6093,
    longitude: 85.1376,
    keywords: ['kankarbagh', 'bailey road', 'gaya', 'muzaffarpur', 'bhagalpur'],
  },
  {
    google_place_id: 'ChIJ_ranchi_jh',
    formatted_address: 'Main Road & Nucleus Mall, Ranchi, Jharkhand 834001, India',
    main_text: 'Main Road & Nucleus Mall, Ranchi',
    secondary_text: 'Ranchi, Jharkhand 834001, India',
    country: 'India',
    state: 'Jharkhand',
    district: 'Ranchi',
    city: 'Ranchi',
    postal_code: '834001',
    latitude: 23.3441,
    longitude: 85.3096,
    keywords: ['jamshedpur', 'bistupur', 'sakchi', 'dhanbad', 'bokaro', 'deoghar'],
  },
  {
    google_place_id: 'ChIJ_lucknow_up',
    formatted_address: 'Hazratganj & Gomti Nagar, Lucknow, Uttar Pradesh 226001, India',
    main_text: 'Hazratganj & Gomti Nagar, Lucknow',
    secondary_text: 'Lucknow, Uttar Pradesh 226001, India',
    country: 'India',
    state: 'Uttar Pradesh',
    district: 'Lucknow',
    city: 'Lucknow',
    postal_code: '226001',
    latitude: 26.8467,
    longitude: 80.9462,
    keywords: ['phoenix palassio', 'lulu mall lucknow', 'varanassi', 'varanasi', 'agra', 'kanpur', 'prayagraj', 'allahabad'],
  },
  {
    google_place_id: 'ChIJ_chandigarh_ch',
    formatted_address: 'Sector 17 Plaza & Elante Mall, Chandigarh 160017, India',
    main_text: 'Sector 17 & Elante Mall, Chandigarh',
    secondary_text: 'Chandigarh 160017, India',
    country: 'India',
    state: 'Chandigarh',
    district: 'Chandigarh',
    city: 'Chandigarh',
    postal_code: '160017',
    latitude: 30.7333,
    longitude: 76.7794,
    keywords: ['mohali', 'panchkula', 'sector 35', 'amritsar', 'ludhiana', 'jalandhar', 'shimla', 'manali', 'dehradun', 'rishikesh'],
  },
  {
    google_place_id: 'ChIJ_indore_mp',
    formatted_address: 'Vijay Nagar & C21 Mall, Indore, Madhya Pradesh 452010, India',
    main_text: 'Vijay Nagar & C21 Mall, Indore',
    secondary_text: 'Indore, Madhya Pradesh 452010, India',
    country: 'India',
    state: 'Madhya Pradesh',
    district: 'Indore',
    city: 'Indore',
    postal_code: '452010',
    latitude: 22.7533,
    longitude: 75.8937,
    keywords: ['sarafa', 'chhappan dukan', 'bhopal', 'gwalior', 'jabalpur', 'raipur', 'bilaspur'],
  },
];

function normalizeSearchText(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Performs tokenized, relevance-ranked search across curated Indian locations.
 * Returns empty array [] when no real location matches (never fabricates fake places).
 */
export function searchCuratedIndianLocations(
  query: string,
  limit = 8
): CuratedIndianLocation[] {
  const normalizedQuery = normalizeSearchText(query || '');
  if (normalizedQuery.length < 2) {
    return [];
  }

  const tokens = normalizedQuery.split(' ').filter(Boolean);
  if (tokens.length === 0) {
    return [];
  }

  const scored: { item: CuratedIndianLocation; score: number }[] = [];

  for (const loc of INDIAN_LOCATIONS_DATA) {
    const mainNorm = normalizeSearchText(loc.main_text);
    const cityNorm = normalizeSearchText(loc.city);
    const districtNorm = normalizeSearchText(loc.district);
    const stateNorm = normalizeSearchText(loc.state);
    const addressNorm = normalizeSearchText(loc.formatted_address);
    const postalNorm = normalizeSearchText(loc.postal_code);
    const keywordsNorm = normalizeSearchText((loc.keywords || []).join(' '));

    const searchableBlob = `${mainNorm} ${cityNorm} ${districtNorm} ${stateNorm} ${postalNorm} ${addressNorm} ${keywordsNorm}`;

    // Every query token must match somewhere in the location record
    const allTokensMatch = tokens.every((token) => searchableBlob.includes(token));
    if (!allTokensMatch) {
      continue;
    }

    let score = 10;
    if (postalNorm === normalizedQuery || postalNorm.startsWith(normalizedQuery)) {
      score += 100;
    }
    if (cityNorm === normalizedQuery || mainNorm === normalizedQuery) {
      score += 90;
    } else if (mainNorm.startsWith(normalizedQuery) || cityNorm.startsWith(normalizedQuery)) {
      score += 70;
    } else if (keywordsNorm.includes(normalizedQuery)) {
      score += 55;
    } else if (districtNorm.startsWith(normalizedQuery) || stateNorm.startsWith(normalizedQuery)) {
      score += 45;
    }

    for (const token of tokens) {
      if (mainNorm.startsWith(token) || cityNorm.startsWith(token)) {
        score += 15;
      } else if (mainNorm.includes(token) || cityNorm.includes(token)) {
        score += 10;
      } else if (keywordsNorm.includes(token)) {
        score += 8;
      }
    }

    scored.push({ item: loc, score });
  }

  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function findCuratedIndianLocationByPlaceId(
  placeId: string
): CuratedIndianLocation | undefined {
  return INDIAN_LOCATIONS_DATA.find((loc) => loc.google_place_id === placeId);
}
